/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type { ListHomepagePinsQueryResponse } from '../../types/ListHomepagePins'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listHomepagePins } from '../../clients/listHomepagePins'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listHomepagePinsQueryKey = () =>
  [{ url: '/api/v1/homepage/pins/' }] as const

export type ListHomepagePinsQueryKey = ReturnType<
  typeof listHomepagePinsQueryKey
>

export function listHomepagePinsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listHomepagePinsQueryKey()
  return queryOptions<
    ListHomepagePinsQueryResponse,
    ResponseErrorConfig<Error>,
    ListHomepagePinsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listHomepagePins({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary List the current user's homepage pins
 * {@link /api/v1/homepage/pins/}
 */
export function useListHomepagePins<
  TData = ListHomepagePinsQueryResponse,
  TQueryData = ListHomepagePinsQueryResponse,
  TQueryKey extends QueryKey = ListHomepagePinsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListHomepagePinsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listHomepagePinsQueryKey()

  const query = useQuery(
    {
      ...listHomepagePinsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
